let spinnerTimeout = null, opacityTimeout = null;
const loadedScripts = [];
let spinnerStartTime = 0;
/**
 * Remove by value
 * @returns {Array}
 */
Array.prototype.remove = function () {
    let what, a = arguments, L = a.length, ax;
    while (L && this.length) {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
        }
    }
    return this;
};
if (window.Element) {
    Element.prototype.render = function () {
        "use strict";
        this.offsetHeight;
        return this;
    };
}

function _doDisableSpinner() {
    let $spin = $(".cart_item_loader");
    if (!$spin) {
        return;
    }
    $spin.css({"opacity": 0})[0].render();
    spinnerTimeout = setTimeout(function () {
        spinnerTimeout = null;
        $spin.hide();
    }, 400);
}
const Utils = {
    fetchJson(url, query, method){
        if (method === undefined) {
            method = "GET";
        }
        let conf = {method, credentials: 'same-origin'};
        if (method == "POST") {
            if (query instanceof FormData) {
                conf.body = query;
            } else {

                var data = new FormData();
                Object.keys(query).map(k => `${data.append(k, query[k])}`);
                conf.body = data;
            }
        } else {
            if (query && method == "GET") {
                url += '?' + Object.keys(query).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(query[k])}`).join('&');
            }
        }
        return fetch(
            url,
            conf
        ).then((response) => {
            if (response.status >= 200 && response.status < 300) {
                return response
            } else {
                var error = new Error(response.statusText)
                error.response = response
                throw error
            }
        }).then((promise) => {
            let json = promise.json();
            if (json['error'] !== undefined) {
                alert("Promise failed: " + json['error']);
            }
            return json;
        });
    },
    dietCases(more) {
        let number = '';
        if (more == 1) {
            number = 'dzień diety';
        } else if (more >= 5) {
            number = 'dni diety';
        } else {
            number = 'dni diety';
        }
        return more + ' ' + number;
    },

    processValidationError(id, $el, msg) {

        if (msg != null) {
            if ($el.parent().find(".checkout_errors").length == 0) {
                $el.parent().append("<div class='checkout_errors checkout_errors_" + id + "'>" + msg + "</div>")
            } else {
                $el.parent().find(".checkout_errors").html(msg);
            }
            $el.parent().addClass("woocommerce-invalid woocommerce-invalid-required-field").removeClass("woocommerce-validated");
            return 1;
        } else {
            $el.parent().find(".checkout_errors").text('');
            $el.parent().removeClass("woocommerce-invalid woocommerce-invalid-required-field");
            return 0;
        }
    },

    maskZipCode(id) {
        const selector = document.getElementById(id);
        const im = new Inputmask("99-999");
        im.mask(selector);
        $("#" + id).blur(function (ev) {
            const that = this;
            ev.stopPropagation();
            setTimeout(function () {
                if (Inputmask.isValid($(that).val(), {alias: '99-999'})) {
                    $(`#${id}_field`).addClass("woocommerce-validated");
                } else {
                    $(`#${id}_field`).removeClass("woocommerce-validated").addClass("woocommerce-invalid").addClass("woocommerce-invalid-required-field");

                }
            }, 100);
        });
    },
    is_phone(phone) {
        return !(0 < phone.replace(/[\s\#0-9_\-\+\(\)]/g, '').trim().length);
    }, is_postcode(postcode /*country: poland*/) {
        return !(postcode.replace(/[\s\-A-Za-z0-9]/g, '').trim().length > 0);
    },
    // NIP validation, taken from:
    // http://blog.aleksander.kaweczynski.pl/walidacja-numerow-pesel-nip-regon-w-javascript-i-php/
    validate_nip(nip) {
        let nip_bez_kresek = nip.replace(/-/g, "");
        let reg = /^[0-9]{10}$/;
        if (reg.test(nip_bez_kresek) == false) {
            return false;
        }
        else {
            let dig = ("" + nip_bez_kresek).split("");
            let kontrola = (
                    6 * parseInt(dig[0])
                    + 5 * parseInt(dig[1])
                    + 7 * parseInt(dig[2])
                    + 2 * parseInt(dig[3])
                    + 3 * parseInt(dig[4])
                    + 4 * parseInt(dig[5])
                    + 5 * parseInt(dig[6])
                    + 6 * parseInt(dig[7])
                    + 7 * parseInt(dig[8])
                ) % 11;
            return parseInt(dig[9]) == kontrola;
        }

    },
    elementInViewport(el, offsetTop) {
        if (el instanceof jQuery) {
            el = el[0];
        }
        let top = el.offsetTop;
        let left = el.offsetLeft;
        const width = el.offsetWidth;
        const height = el.offsetHeight;

        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }
        top -= offsetTop;
        return (
            top >= window.pageYOffset &&
            left >= window.pageXOffset &&
            (top + height) <= (window.pageYOffset + window.innerHeight) &&
            (left + width) <= (window.pageXOffset + window.innerWidth)
        );
    },
    putSpinnerOn(el, isFixed) {
        if (typeof el == 'string') {
            el = $(el);
        }
        if (el === undefined) {
            isFixed = true;
            el = $("body");
        }
        clearTimeout(opacityTimeout);
        clearTimeout(spinnerTimeout);
        let $el = $(el);
        let off = $el.offset();
        let $spin = $(".cart_item_loader");
        if (!$spin) {
            return;
        }
        $spin.css({
            display: "flex",
            // display: "block",
            left: off.left + "px",
            top: off.top + "px",
            width: $el.outerWidth() + "px",
            height: $el.outerHeight() + "px",
            opacity: 0,
            position: isFixed ? 'fixed' : 'absolute'
        });
        $spin[0].render();
        $spin.css({opacity: 1});
        spinnerStartTime = Date.now();
    },
    /**
     * If minTimeout is object as {min:INTEGER}, it checks how long spinner has been running. If less than INTEGER, it sets timeout
     * @param minTimeout
     * @param afterTimeout
     */
    disableSpinner(timeout, afterTimeout) {
        if (typeof timeout == "object") {
            timeout = timeout.min;
            let diff = Date.now() - spinnerStartTime;
            if (diff < timeout) {
                timeout = timeout - diff;
            }
        }
        clearTimeout(opacityTimeout);
        if (timeout) {
            opacityTimeout = setTimeout(function () {
                _doDisableSpinner();
                if (afterTimeout) {
                    afterTimeout();
                }
            }, timeout);
        } else {
            _doDisableSpinner();
        }
    }

};
export default Utils;



// WEBPACK FOOTER //
// ./assets/js/utils.js